/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_InstalledInputs */



/**
* | output |
* | --- |
* | "Installed packages" |
*
* @param {Partner_Connectors_InstalledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_installed = /** @type {((inputs?: Partner_Connectors_InstalledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_InstalledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Installierte Pakete")
	return /** @type {LocalizedString} */ ("Installed packages")
});